import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './ShiftTimePicker.css';
import './StaffPicker.css';

class StaffPicker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            isMobile: typeof window !== 'undefined' && window.innerWidth < 768,
            search: '',
        };
        this.listRef = React.createRef();
        this.inputRef = React.createRef();
        this.searchRef = React.createRef();
    }

    componentDidMount() {
        this._resizeHandler = () => {
            this.setState({ isMobile: window.innerWidth < 768 });
        };
        window.addEventListener('resize', this._resizeHandler);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this._resizeHandler);
    }

    componentDidUpdate(_, prevState) {
        if (!prevState.open && this.state.open) {
            requestAnimationFrame(() => {
                if (!this.listRef.current) return;
                const sel = this.listRef.current.querySelector('.stp-slot--selected');
                if (sel) sel.scrollIntoView({ block: 'center' });
            });
        }
    }

    getSelectedName() {
        const { staffList, value } = this.props;
        if (!staffList || !value) return '';
        const found = staffList.find(s => s.id === value);
        return found ? found.name : '';
    }

    open = () => {
        this.setState({ open: true, search: '' }, () => {
            requestAnimationFrame(() => {
                if (this.searchRef.current) this.searchRef.current.focus();
            });
        });
    }

    // searchable={false}: a short fixed list (e.g. Repeat in New Booking)
    // uses the same picker without the search box
    searchable() { return this.props.searchable !== false; }

    select = (id) => {
        this.setState({ open: false });
        if (this.props.onChange) this.props.onChange(id);
    }

    close = () => {
        this.setState({ open: false });
    }

    getDesktopPosition() {
        if (!this.inputRef.current) return {};
        const rect = this.inputRef.current.getBoundingClientRect();
        const spaceBelow = window.innerHeight - rect.bottom;
        const dropUp = spaceBelow < 320;
        return {
            position: 'fixed',
            left: rect.left,
            width: Math.max(rect.width, 220),
            ...(dropUp
                ? { bottom: window.innerHeight - rect.top + 4 }
                : { top: rect.bottom + 4 }
            ),
        };
    }

    renderList() {
        const { staffList, value } = this.props;
        const { search } = this.state;
        if (!staffList) return null;
        const query = search.toLowerCase().trim();
        const filtered = query
            ? staffList.filter(s => (s.name || '').toLowerCase().includes(query))
            : staffList;
        return (
            <>
                {this.searchable() && <div className="staff-picker-search">
                    <svg className="staff-picker-search-icon" width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <circle cx="6" cy="6" r="4.5" stroke="currentColor" strokeWidth="1.2"/>
                        <path d="M9.5 9.5L12.5 12.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
                    </svg>
                    <input
                        ref={this.searchRef}
                        type="text"
                        className="staff-picker-search-input"
                        placeholder="Search staff..."
                        value={search}
                        onChange={(e) => this.setState({ search: e.target.value })}
                    />
                </div>}
                <div className="staff-picker-list" ref={this.listRef}>
                    {filtered.length === 0 && (
                        <div className="staff-picker-empty">No results</div>
                    )}
                    {filtered.map(s => (
                        <button
                            key={s.id}
                            type="button"
                            className={'staff-picker-item' + (s.id === value ? ' staff-picker-item--selected' : '')}
                            onClick={() => this.select(s.id)}
                        >
                            <span className="staff-picker-item-name">{s.name}</span>
                            {s.id === value && (
                                <svg className="staff-picker-item-check" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                    <path d="M3 7.5L5.5 10L11 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            )}
                        </button>
                    ))}
                </div>
            </>
        );
    }

    renderDesktop() {
        if (!this.state.open) return null;
        return ReactDOM.createPortal(
            <React.Fragment>
                <div className="stp-desktop-backdrop" onClick={this.close} />
                <div className="staff-picker-dropdown" style={this.getDesktopPosition()}>
                    {this.renderList()}
                </div>
            </React.Fragment>,
            document.body
        );
    }

    renderMobile() {
        if (!this.state.open) return null;
        return ReactDOM.createPortal(
            <div className="stp-mobile-overlay" onClick={this.close}>
                <div className="stp-mobile-sheet" onClick={e => e.stopPropagation()}>
                    <div className="stp-sheet-header">
                        <span className="stp-sheet-title">{this.props.label || 'Staff Member'}</span>
                        <button type="button" className="stp-sheet-close" onClick={this.close}>
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path d="M1 1L13 13M13 1L1 13" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                            </svg>
                        </button>
                    </div>
                    <div className="stp-sheet-divider" />
                    {this.renderList()}
                </div>
            </div>,
            document.body
        );
    }

    render() {
        const name = this.getSelectedName();
        return (
            <React.Fragment>
                <div
                    ref={this.inputRef}
                    className="stp-input"
                    onClick={this.open}
                >
                    <span className={name ? 'stp-input-value' : 'stp-input-placeholder'}>
                        {name || this.props.placeholder || 'Select staff'}
                    </span>
                </div>
                {this.state.isMobile ? this.renderMobile() : this.renderDesktop()}
            </React.Fragment>
        );
    }
}

export default StaffPicker;
